import api from './api';

export const logFunctionalityId = (functionalityId: string) =>
  api.post({
    path: `/logs`,
    body: {
      functionalityId,
    },
  });
